module.exports = __webpack_public_path__ + "img/grid-third.0a92053d.svg";